// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.physical-dashboard{
  height: 100vh;
  overflow: hidden;
  background: var(--Neutral-50, #F8FAFC);
}

.maincontentarea-physical{
  display: flex;
  padding-bottom: 1.5rem; 
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  background: var(--Neutral-50, #F8FAFC);
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Physical-Assessment/Physical-Assessment.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;AACb","sourcesContent":["\n.physical-dashboard{\n  height: 100vh;\n  overflow: hidden;\n  background: var(--Neutral-50, #F8FAFC);\n}\n\n.maincontentarea-physical{\n  display: flex;\n  padding-bottom: 1.5rem; \n  justify-content: space-between;\n  align-items: flex-start;\n  align-self: stretch;\n  background: var(--Neutral-50, #F8FAFC);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
